/** A doc-page-with-plus glyph for "new file". */
export function NewFileIcon(): JSX.Element {
  return (
    <svg className="dw-add-icon" width="14" height="14" viewBox="0 0 16 16" aria-hidden="true">
      <path d="M3 1.5h6L13 5.5V14.5H3z" fill="none" stroke="currentColor" strokeWidth="1.2" strokeLinejoin="round" />
      <path d="M9 1.5V5.5H13" fill="none" stroke="currentColor" strokeWidth="1.2" strokeLinejoin="round" />
      <path d="M8 8v4M6 10h4" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" />
    </svg>
  );
}

/** A folder-with-plus glyph for "new directory". */
export function NewDirIcon(): JSX.Element {
  return (
    <svg className="dw-add-icon" width="14" height="14" viewBox="0 0 16 16" aria-hidden="true">
      <path d="M1.5 4h4l1.2 1.5H14.5v8.5h-13z" fill="none" stroke="currentColor" strokeWidth="1.2" strokeLinejoin="round" />
      <path d="M8 8.5v3.5M6.25 10.25h3.5" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" />
    </svg>
  );
}

/** A chevron-up in a rounded square — "collapse all folders". */
export function CollapseAllIcon(): JSX.Element {
  return (
    <svg className="dw-add-icon" width="14" height="14" viewBox="0 0 16 16" aria-hidden="true">
      <rect x="1.5" y="1.5" width="13" height="13" rx="3" fill="none" stroke="currentColor" strokeWidth="1.2" />
      <path d="M4.75 9.25L8 6L11.25 9.25" fill="none" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

/** An × — "close": leave a hidden repo's focused sidebar for all repos. */
export function CloseIcon(): JSX.Element {
  return (
    <svg className="dw-add-icon" width="14" height="14" viewBox="0 0 16 16" aria-hidden="true">
      <path d="M4 4l8 8M12 4l-8 8" fill="none" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" />
    </svg>
  );
}

/** A chevron-down in a rounded square — "expand all folders". */
export function ExpandAllIcon(): JSX.Element {
  return (
    <svg className="dw-add-icon" width="14" height="14" viewBox="0 0 16 16" aria-hidden="true">
      <rect x="1.5" y="1.5" width="13" height="13" rx="3" fill="none" stroke="currentColor" strokeWidth="1.2" />
      <path d="M4.75 6.75L8 10L11.25 6.75" fill="none" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

/** Box with an arrow leaving it — "share". */
export function ShareIcon(): JSX.Element {
  return (
    <svg className="dw-share-icon" width="14" height="14" viewBox="0 0 16 16" aria-hidden="true">
      <path d="M6 3.5H2.5v10h10V10" fill="none" stroke="currentColor" strokeWidth="1.2" strokeLinejoin="round" />
      <path d="M8 8l6-6M9.5 2H14v4.5" fill="none" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}
